/**
 * @generated SignedSource<<e64fa0e9de467e0a7d806772f2d07669>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamScheduleAdminTemplateScreenMutation$variables = {
  teamId: string;
  templateId: string;
};
export type TeamScheduleAdminTemplateScreenMutation$data = {
  readonly createRoutineFromTemplate: {
    readonly id: string;
  } | null;
};
export type TeamScheduleAdminTemplateScreenMutation = {
  response: TeamScheduleAdminTemplateScreenMutation$data;
  variables: TeamScheduleAdminTemplateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
      },
      {
        "kind": "Variable",
        "name": "templateId",
        "variableName": "templateId"
      }
    ],
    "concreteType": "Routine",
    "kind": "LinkedField",
    "name": "createRoutineFromTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleAdminTemplateScreenMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamScheduleAdminTemplateScreenMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "41060ab6993e209d11363dfba0f084e8",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleAdminTemplateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation TeamScheduleAdminTemplateScreenMutation(\n  $templateId: ID!\n  $teamId: ID!\n) {\n  createRoutineFromTemplate(templateId: $templateId, teamId: $teamId) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d496c742006a151255f99a3316ea8485";

export default node;
